import { api } from "@/api/client";

export const MAX_AVATAR_BYTES = 3 * 1024 * 1024;

export async function uploadAvatar(_userId: string, file: File): Promise<string> {
  if (!file.type.startsWith("image/")) throw new Error("Bitte ein Bild auswählen");
  if (file.size > MAX_AVATAR_BYTES) throw new Error("Bild ist zu groß (max. 3 MB)");
  const r = await api.profiles.uploadAvatar(file);
  return r.url;
}

export async function removeAvatar(_userId?: string): Promise<void> {
  await api.profiles.deleteAvatar();
}
